import { render, staticRenderFns } from "./homeCompetitionDownload.vue?vue&type=template&id=24b4e07a&scoped=true&"
import script from "./homeCompetitionDownload.vue?vue&type=script&lang=ts&"
export * from "./homeCompetitionDownload.vue?vue&type=script&lang=ts&"
import style0 from "./homeCompetitionDownload.vue?vue&type=style&index=0&id=24b4e07a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b4e07a",
  null
  
)

export default component.exports